export class LabeledTextInput {

   constructor(element, settings) {

      if (typeof(element) === 'string') {
         element = document.querySelector(element);
      }

      let defaults = {
         labelText:   null,
         type: null,
         labelOpacity: .3,
         onChanging: function() { },
         clearButton: false
      };

      this.set = Object.extend(true, defaults, settings);

      this.elMain = HTMLElement.createFromHTML(
         '<div class="labeled-text-input">'
       + '   <div class="label">'
       + '      <div class="label-text"></div>'
       + '   </div>'
       + '   <i class="icon-cross btn-clear"></i>'
       + '</div>'
      );

      this.elLabel = this.elMain.querySelector('.label');
      this.elLabelText = this.elLabel.querySelector('.label-text');      
      this.elBtnClear = this.elMain.querySelector('.btn-clear');

      if (!this.set.clearButton) {
         this.elBtnClear.style.display = 'none';
      }

      this.elLabelText.innerHTML = this.set.labelText;

      this.elText = element.parentNode.replaceChild(this.elMain, element);
      this.elLabel.appendChild(this.elText);
      this.elLabelText.style.opacity = this.set.labelOpacity;
      
      requestAnimationFrame(() => {
         let style = window.getComputedStyle(element);
         this.elMain.style.fontSize = style.fontSize;
         this.elMain.style.fontFamily = style.fontFamily;
         this.elMain.style.height = style.height;
      });

      this.elBtnClear.onclick = (event) => {
         event.stopPropagation();
         this.setValue('');
      }

      element.onclick = (event) => event.stopPropagation();
      element.onkeyup = (event) => {
         this.update();
      }

   }

   update() {
      this.elLabelText.innerHTML = this.elText.value.length === 0 ? this.set.labelText : '';
      this.set.onChanging(this.elText.value);
   }

   getValue() {
      return this.elText.value;
   }

   setValue(value) {
      this.elText.value = value;
      this.update();
   }

}
